import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { SUPPORT_TEL_HREF } from 'utils/constants';

const FONT_FAMILY = "'Thmanyah Sans', 'Noto Sans Arabic', 'Noto Sans', sans-serif";
const PRIMARY = '#FF5C4F'; // color-primary-500
const PRIMARY_HOVER = '#F2493D';
const PRIMARY_ACTIVE = '#E03D32';

/**
 * "عندك سؤال؟" FAQ / support CTA band at the foot of the Terms page (TZ-377).
 * Branded coral on a light peach band; content is start-aligned (right in RTL)
 * to match the Figma. Buttons sit in a right-aligned row and wrap on narrow screens.
 */
export const FaqSupportCta = () => {
  // TODO(TZ-377): point at the FAQ page once it exists (no route yet).
  const handleFaqClick = () => {
    // no-op stub — FAQ destination not built
  };

  return (
    <Box as='section' dir='rtl' bg='#FFF1EF'>
      <Box
        maxW='container.xl'
        mx='auto'
        px={{ base: '16px', md: '100px' }}
        py={{ base: '40px', md: '56px' }}
        textAlign='start'
      >
        <Text
          as='h2'
          m={0}
          color={PRIMARY}
          fontFamily={FONT_FAMILY}
          fontWeight='900'
          fontSize={{ base: '24px', md: '28px' }}
          lineHeight='1.2'
          letterSpacing='-0.01em'
        >
          <FormattedMessage id='terms.faq.heading' defaultMessage='Have a question?' />
        </Text>

        <Text
          mt={{ base: '8px', md: '12px' }}
          mb={0}
          color='#57534D' // text-secondary
          fontFamily={FONT_FAMILY}
          fontWeight='400'
          fontSize={{ base: '14px', md: '15px' }}
          lineHeight='1.5'
        >
          <FormattedMessage
            id='terms.faq.subtitle'
            defaultMessage='Our support team is ready to answer your questions.'
          />
        </Text>

        <Flex
          mt={{ base: '20px', md: '24px' }}
          gap={{ base: '12px', md: '16px' }}
          justify='flex-start'
          align='center'
          flexWrap='wrap'
        >
          {/* Contact — dials the support hotline */}
          <Button
            as='a'
            href={SUPPORT_TEL_HREF}
            h='48px'
            px='32px'
            borderRadius='full'
            fontFamily={FONT_FAMILY}
            fontWeight='700'
            fontSize='15px'
            bg={PRIMARY}
            color='white'
            _hover={{ bg: PRIMARY_HOVER, textDecoration: 'none' }}
            _active={{ bg: PRIMARY_ACTIVE }}
          >
            <FormattedMessage id='terms.faq.contact' defaultMessage='Contact us' />
          </Button>

          {/* FAQ — stubbed (no FAQ page yet); see TODO above */}
          <Button
            onClick={handleFaqClick}
            h='48px'
            px='32px'
            borderRadius='full'
            fontFamily={FONT_FAMILY}
            fontWeight='700'
            fontSize='15px'
            bg='transparent'
            color='#1B1917' // text-primary
            borderWidth='1px'
            borderColor='#D4CAC5'
            _hover={{ bg: 'rgba(0, 0, 0, 0.04)', borderColor: '#B9B2AB' }}
            _active={{ bg: 'rgba(0, 0, 0, 0.07)', borderColor: '#A39C95' }}
          >
            <FormattedMessage id='terms.faq.faqs' defaultMessage='FAQs' />
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};
